import React, {ChangeEventHandler} from "react";
import {EditBrandMapBodyFrontend} from "../../pages/brands/components/BrandMapFormValues";
import UploadImagePreview from "../cards/UploadImagePreview";

interface Props {
    formValues: EditBrandMapBodyFrontend;
    onInputChange: (key: keyof EditBrandMapBodyFrontend) => ChangeEventHandler<HTMLInputElement>;
    onImageChange: (key: "preAutoMintToastBackground") => ChangeEventHandler<HTMLInputElement>;
    onRemoveImage: (key: "preAutoMintToastBackground") => void;
}

function MerchantBrandMapPreAutoMintToast(props: Props) {
    return (
        <div className="create-map-page_container">
            <div className="create-map-page_container_inner create-map-page_main-promo_title">
                <h5>
                    Pre Auto-mint Toast
                </h5>
                <p className="merchant-brand-title-description_content_subtitle">
                    This toast will appear to a user before an auto-mint mint is triggered.
                    Its purpose is to inform the end user that there is a waiting period before the mint is complete.
                    It will be dismissed after the minting is finished.
                </p>

                <div className="create-map-page_automint-toast">
                    <div className="create-map-page_automint-toast_field">
                        <p>
                            Toast Message
                        </p>
                        <input
                            placeholder="E.g. You're eligible for a free NFT! Please remain on this page, and wait while we get it ready..."
                            value={props.formValues.preAutoMintToastMessage}
                            onChange={props.onInputChange("preAutoMintToastMessage")}
                        />
                    </div>

                    <div className="create-map-page_automint-toast_field">
                        <p>
                            Preview of Toast Background Image
                        </p>
                        <UploadImagePreview
                            <EditBrandMapBodyFrontend>
                            onImageChange={props.onImageChange}
                            onRemoveImage={props.onRemoveImage}
                            image={props.formValues.preAutoMintToastBackground}
                            fieldName="preAutoMintToastBackground"
                            optional={true}
                            isToastPreview={true}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MerchantBrandMapPreAutoMintToast;